import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'


/**
 * Renders a List Item type anchor element that either opens in the same window for
 * "internal" links, or in a new window/tab for external links.
 */
class LinkItem extends React.Component {

  render() {
    const { link, title, text } = this.props;
    let internal = link.startsWith('https://www.nutrfy.com/') || link.startsWith('/');

    return (
      <>
      {internal ? 
      <li className="list-group-item"><a href={link} title={title}>{text}</a></li>
      :
      <li className="list-group-item"><a href={link} title={title} target="_blank" rel="noopener noreferrer">{text}</a> <span className="external-link"><FontAwesomeIcon className="text-center" icon={faExternalLinkAlt}/></span></li>
}
  </>
  )

  }
  
}
export default LinkItem;